/** @format */

import * as React from 'react';
import {useEffect, useRef} from 'react';

import {cn, addTWPrefixToClasses} from '@/lib/utils';

const Textarea = React.forwardRef(({className, ...props}, ref) => {
    const textareaRef = useRef(null);
    const combinedRef = ref || textareaRef;

    useEffect(() => {
        const textarea = combinedRef.current;
        if (!textarea) return;

        const autoResize = () => {
            textarea.style.height = 'auto';
            textarea.style.height = `${textarea.scrollHeight}px`;
        };

        textarea.addEventListener('input', autoResize);
        autoResize(); // Initial resize

        return () => {
            textarea.removeEventListener('input', autoResize);
        };
    }, [combinedRef]);

    return (
        <textarea
            className={cn(
                'tw-flex tw-w-full tw-rounded-md tw-border tw-border-indigo-200 tw-bg-background tw-px-3 tw-py-2 tw-text-base tw-ring-offset-background tw-placeholder:text-gray-500 focus-visible:tw-outline-none focus-visible:tw-border-2 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 md:tw-text-sm tw-resize-none',
                addTWPrefixToClasses(className)
            )}
            ref={combinedRef}
            {...props}
        />
    );
});
Textarea.displayName = 'Textarea';

export {Textarea};
